import Vue from 'vue'
import store from './../store/index'

export const supportedCurrencies = [
  {
    label: 'Schweizer Franken - CHF',
    short: 'CHF',
    value: 'chf',
    local: 'de-ch'
  },
  {
    label: 'Euro - EUR (€)',
    short: '€',
    value: 'eur',
    local: 'de-de'
  },
  {
    label: 'US-Dollar - USD ($)',
    short: '$',
    value: 'usd',
    local: 'en-us'
  },
  {
    label: 'Pfund Sterling - GBP (£)',
    short: '£',
    value: 'gbp',
    local: 'en-gb'
  }
]

export const supportedWeight = [
  {
    label: 'Kilogramm (kg)',
    short: 'kg',
    value: 'kg'
  },
  {
    label: 'Gramm (g)',
    short: 'g',
    value: 'g'
  }
]

const emptyStub = {
  label: '',
  short: '',
  value: ''
}

/*
 * Vue plugin
 */
const MyPlugin = {
  install (Vue, options) {
    Vue.prototype.$supportedCurrencies = supportedCurrencies

    Vue.prototype.$supportedWeight = supportedWeight

    Vue.mixin({
      computed: {
        shop () {
          return store.getters['shop/get']
        },
        shopCurrency () {
          let shopCurrency = supportedCurrencies.find(option => option.value === this.shop.currency)
          if (shopCurrency === undefined) return emptyStub
          return shopCurrency
        },
        shopWeight () {
          let shopWeight = supportedWeight.find(option => option.value === this.shop.weight)
          if (shopWeight === undefined) return emptyStub
          return shopWeight
        }
      }
    })
  }
}

Vue.use(MyPlugin)

export default MyPlugin



// WEBPACK FOOTER //
// ./client/plugins/wsc-shop.js